import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';


interface SmartGuideDto{
    heading: string;
    text: string;
    bgColor: string;
    textColor: string;
}

@Component({
    selector: 'smart-guide',
    templateUrl: './smart-guide.component.html',
    standalone: false
})
export class SmartGuideComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    smartGuideList: SmartGuideDto[] = []


    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.smartGuideList = [
            {
                heading: 'Intro',
                text: 'To start off, I’d like to confirm a few basic details with you. This just helps us make sure everything is up to date and aligned with your current situation.',
                bgColor: 'bg-blue-100',
                textColor: 'text-blue-800'
            },
            {
                heading: 'Willing Customer',
                text: 'Thanks,  I’ll quickly update your personal information — it helps make sure everything fits your profile correctly.',
                bgColor: 'bg-green-100',
                textColor: 'text-green-800'
            },
            {
                heading: 'Hesitant Customer',
                text: 'I understand it might feel a bit personal — the reason we ask for this is to make sure your profile reflects your current life stage. It helps us support you better.',
                bgColor: 'bg-yellow-100',
                textColor: 'text-yellow-800'
            },
            {
                heading: 'Very Hesitant Customer',
                text: 'That’s totally okay — a lot of people feel cautious with this part. We ask only what’s necessary to keep things accurate and helpful for you.',
                bgColor: 'bg-orange-100',
                textColor: 'text-orange-800'
            },
            {
                heading: 'Refuses to Share',
                text: 'That’s absolutely fine — we’ll move on to the next part. You’re in full control of what you’d like to share.',
                bgColor: 'bg-red-100',
                textColor: 'text-red-800'
            }

        ]
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
